import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import './styles.css';
import type { Props } from './types';

/**
 * The beta Insurance panel on the Profile page.
 *
 * A placeholder until the redesign lands, so the beta switch can be tried
 * end to end first.
 */
const InsurancePanel = (_props: Props) => (
  <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-uniform-gray-300 px-4 py-10 text-center dark:border-uniform-gray-600">
    <FontAwesomeIcon icon={faMagicWandSparkles} className="text-xl text-yellow-500" />
    <p className="text-base font-semibold text-uniform-gray-900 dark:text-uniform-gray-100">
      The new Insurance panel is coming soon
    </p>
    <p className="text-sm text-uniform-gray-600 dark:text-uniform-gray-300">
      You&apos;re trying the beta. Switch it off above to go back to the current panel.
    </p>
  </div>
);

export default React.memo(InsurancePanel);
